import React, { Component } from "react";
import { Box, HStack, Text, Spacer } from "@chakra-ui/react";

import InboundQueueGrid from "./InboundQueueGrid";

import ConfigService from "../../../services/ConfigService";
import LocalStorageService from "../../../services/LocalStorageService";
import CoreService from "../../../services/CoreService";

import { ObservationSessionMode } from "../../../models/ObservationSessionMode";







export default class InboundQueuePanel extends Component {

    constructor(props) {
        super(props);
        this.state =
        {
            schema: null,
            selectedRow: null,
            selectedRowId: null
        }

        this.configService = new ConfigService();
        this.localStorageService = new LocalStorageService();
        this.coreService = new CoreService();

        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onMakeObservationRequest = this.onMakeObservationRequest.bind(this);

    }




    onSelectionChanged(newRow)
    {
        this.setState({selectedRow: newRow});
    }

    async onMakeObservationRequest()
    {
        if (!this.state.selectedRow) 
        {
            this.props.onMsgBoxRequest("Warning", "Select an Row first!", '', 'warning');
            return;
        }
        // does user have rights to this schema?
        var schemaId = this.state.selectedRow.header.schemaId;
        var userHasSchema = this.props.userSession.schemas.includes(schemaId);
        if (!userHasSchema)
        {
            this.props.onMsgBoxRequest("Warning", "You don't have access to the Inbound Row schema.", '', 'warning');
            return;
        }
        var schema = this.localStorageService.getSchema(schemaId);
        if (!schema.inboundQueue.Enabled)
        {
            this.props.onMsgBoxRequest("Warning", "The schema does not support inbound Queue observation generation.", '', 'warning');
            return;
        }

        var inboundQueueSchema = schema.inboundQueue;
        var locationMap;
        if (inboundQueueSchema.Filter.UseDataListMapForFilter)
        {
            var locationDataList = this.localStorageService.getDataList(inboundQueueSchema.Filter.FilterDataListId, this.props.userSession.gcid);
            locationMap = locationDataList.data.data;
        };
        var propMap;
        if (inboundQueueSchema.PropMapDataListId)
        {
            var propDataList = this.localStorageService.getDataList(inboundQueueSchema.PropMapDataListId, this.props.userSession.gcid);
            propMap = propDataList.data.data;
        };
        var initialBag = {};


        if (inboundQueueSchema.mraEnabled)
        {      
            var newMraInfo = {};     
            newMraInfo.receiptId = this.state.selectedRow.header.data.TransactionId;
            newMraInfo.tagId = this.state.selectedRow.header.data.TagId;
            newMraInfo.blockId = this.state.selectedRow.detail.data.BlockId;
            newMraInfo.lineId = this.state.selectedRow.detail.data.LineId;
            newMraInfo.palletIds = this.state.selectedRow.detail.detailKeys;
            initialBag["mraInfo"] = newMraInfo;
        }




        propMap.forEach((p) => {
            // find the prop in the actual data 
            // header or detail? (why did I do it this way? I could have just had a "flat" structure!)
            var propMapSplit = p.name.split(".");
            var dataNode = (propMapSplit[0] === '[detail]') ? "detail": "header";
            var dataField = propMapSplit[1];
            var val =  this.state.selectedRow[dataNode]["data"][dataField];
            initialBag[p.id] = val;
        });
        // now we have to deal with the detail. It's possible that the snapshot doesn't represent the actual keys 
        // 
        if (inboundQueueSchema.DetailKeysInfo?.UseDetailKeys)
        {
            var openDetailKeysListResponse = await this.coreService.fetchInboundQueueDetailKeys(schemaId, this.state.selectedRow.header.receiptIdentifier, this.state.selectedRow.detail.receiptDetailIdentifier, this.props.userSession.gcid, this.props.userSession.token);

            initialBag[inboundQueueSchema.DetailKeysInfo.DetailKeysPropId] = openDetailKeysListResponse.dataResult;       //this.state.selectedRow.detail.detailKeys;
        }
        this.props.onObservationPageRequest(ObservationSessionMode.DUPLICATE, schemaId, initialBag);

    }

    render() {

        return (

            <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='15px'>

                <HStack direction='row'>
                    <Text fontSize={{ base: '28px', md: '32px', lg: '36px' }} color='white'>Inbound Queue</Text>
                    <Spacer />
                </HStack>

                <InboundQueueGrid
                    userSession={this.props.userSession}
                    currentLocationId={this.props.currentLocationId}
                    onToastRequest={this.props.onToastRequest}
                    onMsgBoxRequest={this.props.onMsgBoxRequest}
                    onErrorPageRequest={this.props.onErrorPageRequest}
                    autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                    suppressAutoRefresh={this.state.suppressAutoRefresh}
                    onSelectionChanged={this.onSelectionChanged}
                    onMakeObservationRequest={this.onMakeObservationRequest}
                    currentRow={this.state.selectedRow}
                />

            </Box>
        );

    }




}